module.exports = __webpack_public_path__ + "media/images/icons/medicine-admissions-13900fbe6c89237a7f88e8e6be5b2021.svg";